import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PopupHttpErrors } from 'src/app/decorators/http-error/popup-http-errors.decorator';
import { IHello } from '../hello.model';
import { ImpersonateRepository } from '../repositories/impersonate.repository';

@Injectable({
  providedIn: 'root'
})
export class ImpersonateService {

  constructor(private impersonateRepository: ImpersonateRepository) { }

  @PopupHttpErrors()
  public helloUser() : Observable<IHello>{
    return this.impersonateRepository.helloUser();
  }

  @PopupHttpErrors()
  public switchUser(username:string) : Observable<IHello>{
    return this.impersonateRepository.switchUser(username);
  }

  @PopupHttpErrors()
  public exitUser() : Observable<IHello>{
    return this.impersonateRepository.exitUser();
  }
}
